import { getClassNames } from '@ab-core/functions/styles/classNameFormatter';
import type { FC, ReactNode } from 'react';
import React from 'react';
import { StyledTag, StyledTags } from './styled';

export enum TAG_TYPE {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERTIARY = 'tertiary',
    SUCCESS = 'success',
    INFO = 'info',
    WARNING = 'warning',
    ERROR = 'error',
    GOLD = 'gold'
}

export type TagProps = React.ComponentPropsWithoutRef<'div'> & {
    text: ReactNode;
    type?: TAG_TYPE;
};

export const Tag: FC<TagProps> = (props) => {
    const { text, type = TAG_TYPE.PRIMARY, className, ...rest } = props;
    const newClassName = getClassNames({ className, styleNames: [type], prefix: 'tag' });

    return (
        <StyledTag className={newClassName} {...rest}>
            {text}
        </StyledTag>
    );
};

export type TagsProps = React.ComponentPropsWithoutRef<'div'> & {
    tags: Array<TagProps>;
};

export const Tags: FC<TagsProps> = (props) => {
    const { tags, ...rest } = props;

    return (
        <StyledTags {...rest}>
            {tags.map((tag, index) => (
                <Tag {...tag} key={index} />
            ))}
        </StyledTags>
    );
};
